module.exports = __webpack_public_path__ + "img/profile-card-avatar.6a9ba825.svg";